import styles from './move-registration-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { CheckboxLabel, dateFormatter, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, MenuItem, Select, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRegistration } from '../../../_models/registration';
import { ICourse } from '../../../_models/course';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface MoveRegistrationDialogProps {
  onClose: () => void,
  open: boolean,
  course: IRegistration,
  refreshData: () => void
}

export function MoveRegistrationDialog(props: MoveRegistrationDialogProps) {
  const { data: courses }: { data: ICourse[] } = useCourseGetRequestHook(`course/getByCatalogId/${props.course.course.catalogId}`, []);
  const futureCourses = courses?.filter(c => new Date(c.startDate) > new Date());

  const { t } = useTranslation();
  const [selectedCourseId, setSelectedCourseId] = useState<string>('');
  const [sendEmail, setSendEmail] = useState<boolean>(false);
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);


  const fullName = () => {
    return props.course?.person?.firstName + ' ' + props.course?.person?.lastName
  };
  const handleSelectCourse = (data: any) => {
    setSelectedCourseId(data.target.value);
  };
  const selectedCourse = courses.find(c => c.id === selectedCourseId);

  const handleMoveRegistration = () => {
    setLoading(true);
    const body = {
      id: props.course.id,
      person: props.course.person,
      course: courses.find(c => c.id === selectedCourseId),
      canceled: false,
      comments: props.course.comments,
      invoiceInfo: props.course.invoiceInfo,
      registeredBy: props.course.registeredBy,
      company: props.course.company,
      sendEmail: sendEmail,
      hasAnsweredSurvey: props.course.hasAnsweredSurvey,
      hasSentCertificate: props.course.hasSentCertificate
    }
    makeCourseRequest(`course/moveRegistration`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('moveRegistration.movedRegistration'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('moveRegistration.couldNotMoveRegistration'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('moveRegistration.areYouSureYouWantToMoveCourseDate')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-2'>
          {fullName()}
        </Typography>
        <div className='d-inline-flex mb-3'>
          <CheckboxLabel
            label={<span>{t('moveRegistration.sendEmailTo')} {fullName()}</span>}
            onChange={() => setSendEmail(!sendEmail)}
          />
        </div>
        <div className='mb-3'>
          <Select
            label={<span>{t('moveRegistration.moveDate')}</span>}
            sx={{ minWidth: 300 }}
            name='moveDate'
            value={selectedCourseId}
            onChange={handleSelectCourse}>
            {futureCourses.map(c => {
              return <MenuItem
                key={c.id}
                value={c.id}>
                {dateFormatter(c.startDate, true)}
              </MenuItem>
            })}
          </Select>
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='secondary'
          onClick={handleMoveRegistration}
          disabled={loading || !selectedCourse}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.move')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default MoveRegistrationDialog;
